// test1505
(1505 && 0);
